module.exports = __webpack_public_path__ + "img/slide_1.1fde0502.jpg";